<template>
  <main class="main promotion_detail_hello" role="main">
    <div class="main_con">
      <div class="h_con">
        <div class="h_top">
          <div class="h_logo_img">
            <img
              :src="
                require(`@/assets/front/images/internet_commerce/logo_hello_w.png`)
              "
            />
          </div>
          <div class="h_title_img">
            <img
              :src="
                require(`@/assets/front/images/internet_commerce/img_ttl_hello.png`)
              "
            />
          </div>
          <div class="h_gift_txt">상품권 5만원 추가 지급 (선착순 50명)</div>
          <div class="h_notice_txt">*3년 약정, 부가세포함 기준</div>
        </div>
        <div class="h_list_wrap">
          <div class="h_list mb">
            <div class="list_1">
              <div class="h_pd_img">
                <img
                  :src="
                    require(`@/assets/front/images/internet_commerce/img_product_hello_01.png`)
                  "
                />
              </div>
              <div class="h_call pnt" @click="callBtn(0)">
                <div class="h_call_img">
                  <img
                    :src="
                      require(`@/assets/front/images/v2/icons/ic_phone_call.png`)
                    "
                  />
                </div>
                <div class="h_call_txt">상담신청</div>
              </div>
            </div>
            <div class="list_2">
              <div class="h_info_1">
                <div>통신 3사에는 없는 저렴한 가격의 TV+인터넷 상품</div>
                <div>인터넷 사용량 적은 가정에 추천!</div>
              </div>
              <div class="h_info_2">
                <div>
                  - 카카오톡과 간단한 인터넷 서핑이 가능한 무선인터넷 제공
                </div>
                <div>- 지상파, 종편, 뉴스, 예능 등 111개 실속 채널</div>
                <div>
                  - 리모콘 버튼 하나로 바로 즐기는 <span class="fw">OTT</span>
                </div>
              </div>
            </div>
            <div class="list_3">
              <div class="h_txt_1">월 13,200원</div>
              <div class="h_txt_2">제휴카드 적용 시 <span>월 200원</span></div>
              <div class="h_txt_3">(LG헬로비전 하나카드 기준)</div>
            </div>
          </div>

          <div class="h_list mb">
            <div class="list_1">
              <div class="h_pd_img">
                <img
                  :src="
                    require(`@/assets/front/images/internet_commerce/img_product_hello_02.png`)
                  "
                />
              </div>
              <div class="h_call pnt" @click="callBtn(1)">
                <div class="h_call_img">
                  <img
                    :src="
                      require(`@/assets/front/images/v2/icons/ic_phone_call.png`)
                    "
                  />
                </div>
                <div class="h_call_txt">상담신청</div>
              </div>
            </div>
            <div class="list_2">
              <div class="h_info_1">
                <div>통신 3사의 100M 인터넷 가격으로 제공하는 500M+TV 상품</div>
              </div>
              <div class="h_info_2">
                <div>
                  - 불필요한 랜선을 뺀
                  <span class="db">무선전용 기가인터넷</span>
                </div>
                <div>- 지상파, 종편, 뉴스, 예능 등 111개 실속 채널</div>
                <div>
                  - 리모콘 버튼 하나로 바로 즐기는 <span class="fw">OTT</span>
                </div>
              </div>
            </div>
            <div class="list_3">
              <div class="h_txt_1">월 23,400원</div>
              <div class="h_txt_2">
                제휴카드 적용 시 <span>월 10,400원</span>
              </div>
              <div class="h_txt_3">(LG헬로비전 하나카드 기준)</div>
            </div>
          </div>

          <div class="h_list">
            <div class="list_1">
              <div class="h_pd_img">
                <img
                  :src="
                    require(`@/assets/front/images/internet_commerce/img_product_hello_03.png`)
                  "
                />
              </div>
              <div class="h_call pnt" @click="callBtn(2)">
                <div class="h_call_img">
                  <img
                    :src="
                      require(`@/assets/front/images/v2/icons/ic_phone_call.png`)
                    "
                  />
                </div>
                <div class="h_call_txt">상담신청</div>
              </div>
            </div>
            <div class="list_2">
              <div class="h_info_1">
                <div>통신 3사의 100M 인터넷 가격으로 제공하는 500M 상품</div>
              </div>
              <div class="h_info_2">
                <div>
                  - 불필요한 랜선을 뺀
                  <span class="db">무선전용 기가인터넷</span>
                </div>
                <div>- U+ 고품질망의 기가급 속도 인터넷</div>
                <div>
                  - 고화질 영상도 끊김 없는 안정적인 속도의
                  <span class="fw">WiFi</span>
                </div>
              </div>
            </div>
            <div class="list_3">
              <div class="h_txt_1">월 17,000원</div>
              <div class="h_txt_2">
                제휴카드 적용 시 <span>월 4,000원</span>
              </div>
              <div class="h_txt_3">(LG헬로비전 하나카드 기준)</div>
            </div>
          </div>
        </div>
        <div>
          <img
            :src="
              require(`@/assets/front/images/internet_commerce/img_hello_view.png`)
            "
          />
        </div>

        <div class="h_notice">
          <div class="n_title">유의사항</div>

          <div class="n_con">
            <div class="n_sub_title">[혜택]</div>
            <div class="n_txt">
              * 상품권 5만원은 해당 이벤트 페이지로 상담 신청을 남긴 후, 신규
              개통을 완료한 선착순 50분께만 드립니다.
            </div>
            <div class="n_txt">
              * 혜택은 별도의 공지 없이 변경될 수 있습니다.
            </div>
          </div>

          <div class="n_con">
            <div class="n_sub_title">[인터넷/방송 공통]</div>
            <div class="n_txt">
              * 이벤트에 안내된 금액 및 혜택은 3년 약정, 직영몰 할인 적용,
              부가세 포함가입니다.
            </div>
            <div class="n_txt">
              * 가입 전/후 상품 및 조건 변경 시 요금 및 할인 혜택이 변경될 수
              있습니다.
            </div>
            <div class="n_txt">
              * 약정기간 내 상품 해지 및 결합 해지할 경우 서비스 이용료/셋톱박스
              임대료/WiFi 결합 할인에 대한 할인 반환금이 부과됩니다.
            </div>
            <div class="n_txt">* 셋톱박스 이용 및 임대료 안내</div>
            <div class="n_txt">
              * 방송 단독 상품 및 결합 상품은 셋톱박스 이용료가 포함 가격입니다.
            </div>
          </div>

          <div class="n_con">
            <div class="n_sub_title">[인터넷]</div>
            <div class="n_txt">
              * 인터넷은 사용 요금제, 각 지역 및 설치되는 건물 상황에 따라 일부
              속도 차이가 있을 수 있습니다.
            </div>
            <div class="n_txt">
              * 본 상품은 기가군 인터넷(500Mbps 이상) 설치 작업과 동일한 방식을
              사용합니다.
            </div>
            <div class="n_txt">
              * 기가군 인터넷(500Mbps 이상)의 경우 LG U+와 동일 통신망을
              사용합니다.
            </div>
          </div>

          <div class="n_con">
            <div class="n_sub_title">[방송]</div>
            <div class="n_txt">채널기준 : 23년 9월, 양천방송 기준</div>
            <div class="n_txt">
              헬로tv 컨텐츠 중 넷플릭스, SPOTV Prime, 디즈니+ 등 유료 채널
              시청을 희망하실 경우 각 채널에 맞는 별도 이용료(멤버십)을
              지불하셔야 합니다.
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { nativeBrowse, isApp } from '@common/lib/common/utils';

import { mapActions as bannerMapActions } from '@common/store/modules/banner';
import * as bannerTypes from '@common/store/modules/banner/types';

export default {
  name: 'InternetCommerce.PromotionDetailHello',
  components: {},
  data() {
    return {
      callUrl: [
        {
          id: 'PRODUCT_1',
          name: '111개 채널TV+WiFi 상품 상담신청',
          url:
            'https://www.lghellovision.net/GaipPop/CommonGaip_pop.jsp?prodNm=(%ED%8D%BC%EC%8A%A4)111TV,WiFi',
        },
        {
          id: 'PRODUCT_2',
          name: 'WiFi전용 기가인터넷+111TV 상품 상담신청',
          url:
            'https://www.lghellovision.net/GaipPop/CommonGaip_pop.jsp?prodNm=(%ED%8D%BC%EC%8A%A4)WiFi%EC%A0%84%EC%9A%A9%EA%B8%B0%EA%B0%80%EC%9D%B8%ED%84%B0%EB%84%B7,111TV',
        },
        {
          id: 'PRODUCT_3',
          name: 'WiFi전용 기가인터넷 상품 상담신청',
          url:
            'https://www.lghellovision.net/GaipPop/CommonGaip_pop.jsp?prodNm=(%ED%8D%BC%EC%8A%A4)WiFi%EC%A0%84%EC%9A%A9%EA%B8%B0%EA%B0%80%EC%9D%B8%ED%84%B0%EB%84%B7',
        },
      ],
    };
  },
  async created() {},
  async mounted() {},
  updated() {},
  computed: {},
  methods: {
    ...bannerMapActions([bannerTypes.CLICK_VIEW_BANNER]),
    callBtn(index) {
      // 노출 이벤트
      const params = {
        company: 'HELLO',
        campaign: 'PROMOTION_1',
        place: this.callUrl[index].id,
        type: 'CLICK',
      };
      this[bannerTypes.CLICK_VIEW_BANNER](params);

      let url = this.callUrl[index].url;

      if (isApp()) {
        nativeBrowse(url);
      } else {
        window.open(url, '_blank');
      }
    },
  },
};
</script>
